import { SearchableSelectType } from '../components/inputs/searchableSelect';

export const ALL_DROPDOWN_VALUE = 'select-all';

export const ALL_DROPDOWN_OPTION: SearchableSelectType = {
    label: 'All',
    value: ALL_DROPDOWN_VALUE,
};
